/**
 * Wrapper class for MoonPay API errors.
 */
export default class MoonPayApiError extends Error {
  constructor(message: string, public moonPayErrorCode: string) {
    super(message);
  }
}
